<template>
  <div id="listItem" class="grid text-left border-b-2 border-classen__secondary">
    <div>
      <label>{{ getTranslation(translationKey) }}</label>
      <div v-if="isTop" class="small__balloon flex float-right justify-center text-center"><p
        class="transform -rotate-45">Top</p></div>
    </div>
    <label class="font-bold">{{ data }}</label>
  </div>
</template>
<script>
import getTranslation from "../../mixins/getTranslation";

export default {
  name: 'listItem',
  props: {
    data: {required: true},
    translationKey: {required: true},
    isTop: {required: false, default: false}
  },
  mixins: [getTranslation]
}
</script>
<style scoped>
#listItem {
  height: 35px;
  line-height: 35px;
  grid-template-columns: 40% 60%;
}
</style>
